/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toomanyverificationattempts3Inputs */

const en_toomanyverificationattempts3 = /** @type {(inputs: Toomanyverificationattempts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Please wait a moment before trying again.`)
};

const de_toomanyverificationattempts3 = /** @type {(inputs: Toomanyverificationattempts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Versuche. Warte kurz und versuch's dann nochmal.`)
};

/**
* | output |
* | --- |
* | "Too many attempts. Please wait a moment before trying again." |
*
* @param {Toomanyverificationattempts3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const toomanyverificationattempts3 = /** @type {((inputs?: Toomanyverificationattempts3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toomanyverificationattempts3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toomanyverificationattempts3(inputs)
	return de_toomanyverificationattempts3(inputs)
});
export { toomanyverificationattempts3 as "tooManyVerificationAttempts" }